import { schema } from 'normalizr';

import { processOriginNetwork } from '../strategies/originNetwork';

export const originNetworkSchema = new schema.Entity(
  'userOriginNetworks',
  {},
  { processStrategy: processOriginNetwork }
);
